import Descriptions from './Descriptions.js'
import Experience from '../../Experience.js'
import EventEmitter from '../Utils/EventEmitter.js'
import Raycaster  from './Raycaster.js'
import * as THREE from 'three'

export default class Menu extends EventEmitter{
    constructor()
    {
        super()

        // Setup
        this.experience = new Experience()
        this.raycaster = new Raycaster()
        this.descriptions = new Descriptions()
        this.scene = this.experience.scene
        this.input = this.experience.input
        this.resources = this.experience.loader.items

        // HTML CSS
        this.aboutMeHeader = document.getElementById("about")

        // Constants
        this.widthTotal = 16 * 2.5
        this.heightTotal = 9 * 2.5

        this.w = this.widthTotal / 4
        this.h = this.heightTotal / 4

        this.blankColor = new THREE.Color('#030303')
        this.highlightColor = new THREE.Color('#ffffff')

        // Behavior Contants
        this.clicked = false
        this.intersects = null
        this.lastSelected = null
        this.inArea = false

        // Output
        this.apps = new THREE.Group()
        this.links = {}
        this.appCount = 0

        this.createTitle()
        this.createMenu()

        // Events
        this.input.on('press', () => this.onPress())
        this.input.on('release', () => this.onRelease())
    }

    // Initialize Methods
    createTitle()
    {
        const title = this.resources.title
        title.position.y = 9
        title.position.z = 1.8
        title.rotation.x = Math.PI / 32

        this.scene.add(title)
    }

    createMenu()
    {
        this.createPositions()
        this.createGeometry()
        this.loadApps()
        this.fill()
        this.addMenu()
    }

    createPositions()
    {
        this.positions = []

        for(let i = 0; i < 12; i++)
        {
            const pos = {}
            pos.x = ((-3/2) * this.w) + ((i % 4) * this.w)
            pos.y = this.h - (Math.floor(i / 4) * this.h)
            this.positions.push(pos)
        }
    }

    createGeometry()
    {
        this.geometry = new THREE.PlaneGeometry(this.w - 0.3, this.h - 0.3)
    }

    loadApps()
    {
        this.loadLink(this.resources.googleTexture, 0)
        this.loadLink(this.resources.githubTexture, 1)
        this.loadLink(this.resources.linkedinTexture, 2)
        this.loadLink(this.resources.backgroundsTexture, 3)
        this.loadLink(this.resources.uiuxTexture, 4)

        this.loadProject(this.resources.testThumbnail_01, 5)
        this.loadProject(this.resources.marbleThumbnail, 6)
        this.loadProject(this.resources.aboutMeThumbnail, 7)
    }

    fill()
    {
        for(let i = this.appCount; i < 12; i++)
        {
            const smallRect = new THREE.Mesh(
                this.geometry,
                new THREE.MeshBasicMaterial({
                    color: '#030303',
                    transparent: true,
                    opacity: 0.8
                })
            )

            smallRect.position.x = this.positions[i].x
            smallRect.position.y = this.positions[i].y
            smallRect.position.z = -4

            smallRect.name = "filler"

            this.apps.add(smallRect)
        }

        // Raycaster Rectangle
        this.area = new THREE.Mesh(
            new THREE.PlaneGeometry(this.widthTotal * 1.08, this.heightTotal * 3/4 * 1.08),
            new THREE.MeshBasicMaterial({ color: 'red', transparent: true, opacity: 0.0 })
        )
        this.area.position.y = 0.3
        this.area.position.z = -4.5
        this.area.rotation.x = Math.PI / 32
        this.scene.add(this.area)
    }


    addMenu()
    {
        this.apps.rotation.x = Math.PI / 32
        this.scene.add(this.apps)
    }

    // Main Update
    update()
    {
        this.updateRaycaster()
        this.resetMenu()
        this.updateSelect()
        this.animateClick()
    }

    /**
     * Update Methods
     */
    updateRaycaster()
    {
        this.raycaster.update()
        this.intersects = this.raycaster.instance.intersectObjects(this.apps.children)
        this.inArea = !!this.raycaster.instance.intersectObject(this.area).length
        this.play = !!this.raycaster.instance.intersectObject(this.descriptions.playButton).length
        this.back = !!this.raycaster.instance.intersectObject(this.descriptions.backButton).length
    }

    resetMenu()
    {
        for(const item of this.apps.children)
        {
            if(this.inArea)
            {
                if(this.intersects !== null && this.intersects.length && this.intersects[0].object !== item)
                {
                    // Reset colors
                    if(item.material.transparent === true)
                    {
                        item.material.color.lerp(this.blankColor, 0.2)
                    }

                    // Reset position
                    const restPos = item.position.clone()
                    restPos.z = -4
                    item.position.lerp(restPos, 0.5)
                }
                else if(this.lastSelected !== null && this.intersects.length === 0 && item !== this.lastSelected)
                {
                    // Reset colors
                    if(item.material.transparent === true)
                    {
                        item.material.color.lerp(this.blankColor, 0.2)
                    }

                    // Reset position
                    const restPos = item.position.clone()
                    restPos.z = -4
                    item.position.lerp(restPos, 0.5)
                }
            }
            else {
                // Reset colors
                if(item.material.transparent === true)
                {
                    item.material.color.lerp(this.blankColor, 0.2)
                }

                // Reset position
                const restPos = item.position.clone()
                restPos.z = -4
                item.position.lerp(restPos, 0.5)
            }

            this.descriptions.playButton.material.map = this.resources.whtPlayTexture
            this.descriptions.backButton.material.map = this.resources.whtBackTexture
            this.descriptions.playButton.material.needsUpdate = true
            this.descriptions.backButton.material.needsUpdate = true

            // Reset position
            const restPlay =  this.descriptions.playButton.position.clone()
            const restBack =  this.descriptions.backButton.position.clone()
            restPlay.z = -21
            restBack.z = -21
            this.descriptions.playButton.position.lerp(restPlay, 0.5)
            this.descriptions.backButton.position.lerp(restBack, 0.5)
        }
    }

    updateSelect()
    {
        if(this.intersects !== null && this.intersects.length)
        {
            if(this.intersects[0].object.material.transparent === true)
            {
                this.intersects[0].object.material.color.lerp(this.highlightColor, 0.2)
            }

            //Bring forward on Hover
            const selectPos = this.intersects[0].object.position.clone()
            selectPos.z = -2.5
            this.intersects[0].object.position.lerp(selectPos, 0.5)
        }
        else if(this.inArea && this.intersects.length === 0 && this.lastSelected !== null)
        {
            if(this.lastSelected.material.transparent === true)
            {
                this.lastSelected.material.color.lerp(this.highlightColor, 0.2)
            }

            //Bring forward on Hover
            const selectPos = this.lastSelected.position.clone()
            selectPos.z = -2.5
            this.lastSelected.position.lerp(selectPos, 0.5)
        }

        // Witness
        if(this.intersects !== null && this.intersects.length)
        {
            this.raycaster.witness = this.intersects[0]
            this.lastSelected = this.intersects[0].object
        }
        else {
            this.raycaster.witness = null
        }

        //Play Button
        if(this.play)
        {
            this.descriptions.playButton.material.map = this.resources.blkPlayTexture
            this.descriptions.playButton.material.needsUpdate = true
        }
        // Back Button
        if(this.back)
        {
            this.descriptions.backButton.material.map = this.resources.blkBackTexture
            this.descriptions.backButton.material.needsUpdate = true
        }
    }

    animateClick()
    {
        if(this.raycaster.witness !== null)
        {
            const clickPos = this.raycaster.witness.object.position.clone()
            if(this.clicked)
            {
                clickPos.z = -3.5
                this.raycaster.witness.object.position.lerp(clickPos, 0.4)
            }
            else {
                clickPos.z = -2.5
                this.raycaster.witness.object.position.lerp(clickPos, 0.4)
            }
        }

        if(this.play)
        {
            const clickPos = this.descriptions.playButton.position.clone()
            if(this.clicked)
            {
                clickPos.z = -22.5
                this.descriptions.playButton.position.lerp(clickPos, 0.4)
            }
            else {
                clickPos.z = -21
                this.descriptions.playButton.position.lerp(clickPos, 0.4)
            }
        }

        else if(this.back)
        {
            const clickPos = this.descriptions.backButton.position.clone()
            if(this.clicked)
            {
                clickPos.z = -23.5
                this.descriptions.backButton.position.lerp(clickPos, 0.4)
            }
            else {
                clickPos.z = -21
                this.descriptions.backButton.position.lerp(clickPos, 0.4)
            }
        }
    }

    /**
     * Event Callback Methods
     */
    onPress()
    {
        if(this.raycaster.witness)
        {
            if(this.apps.children.includes(this.raycaster.witness.object) && !this.clicked)
            {
                this.clicked = true
            }
        }
        else if(this.play && !this.clicked)
        {
            this.clicked = true
        }
        else if(this.back && !this.clicked)
        {
            this.clicked = true
        }
    }

    onRelease()
    {
        if(this.raycaster.witness !== null && this.apps.children.includes(this.raycaster.witness.object))
        {
            switch(this.raycaster.witness.object) {
                case this.apps.children[0]:
                    window.open(this.links[0])
                    break
                case this.apps.children[1]:
                    window.open(this.links[1])
                    break
                case this.apps.children[2]:
                    window.open(this.links[2])
                    break
                case this.apps.children[3]:
                    window.open(this.links[3], "_blank")
                    break
                case this.apps.children[4]:
                    window.open(this.links[4], "_blank")
                    break
                case this.apps.children[5]:
                    this.descriptions.hide()
                    this.descriptions.show(this.resources.test_01)
                    this.trigger('moveLeft')
                    break
                case this.apps.children[6]:
                    this.descriptions.hide()
                    this.descriptions.show(this.resources.marble_desc_pic)
                    this.trigger('moveLeft')
                    break
                case this.apps.children[7]:
                    this.descriptions.hide()
                    this.descriptions.show(this.resources.aboutMeThumbnail)
                    // this.aboutMeHeader.style.height = "100vh" // show top bar
                    this.trigger('moveLeft')
                    break
                default:
                    break
            }
            this.raycaster.witness = null
        }
        else if(this.play)
        {
            if (this.descriptions.nowShowing === 1)
                window.open("https://apps.nano3dprint.com/", "_blank")
            else
                window.open("https://marble-run.vercel.app/", "_blank")
            this.play = false
        }
        else if(this.back)
        {
            this.trigger('moveToMenu')
            this.aboutMeHeader.style.height = "0" // show top bar
            setTimeout(() => {
                this.descriptions.hide()
            }, 1000)
            this.back = false
        }
        this.clicked = false
    }


    /**
     * Helper Methods
     */
    loadLink(source, pos)
    {
        const material = new THREE.MeshBasicMaterial({
            map: source.file
        })
        material.toneMapped = false

        const mesh = new THREE.Mesh(
            this.geometry,
            material
        )

        mesh.position.x = this.positions[pos].x
        mesh.position.y = this.positions[pos].y
        mesh.position.z = -4

        mesh.name = "link_" + pos

        this.apps.add(mesh)
        this.links[pos] = source.link

        this.appCount += 1

        console.log(this.links)
    }

    loadProject(thumbnail, pos)
    {
        const material = new THREE.MeshBasicMaterial({
            map: thumbnail
        })
        material.toneMapped = false

        const mesh = new THREE.Mesh(
            this.geometry,
            material
        )

        mesh.position.x = this.positions[pos].x
        mesh.position.y = this.positions[pos].y
        mesh.position.z = -4

        mesh.name = "project_" + pos

        this.apps.add(mesh)

        this.appCount += 1
    }
}
